import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Button,
  Input
} from "reactstrap";

const ViewInvoice = () => {
  const [filters, setFilters] = useState({
    fromDateService: "",
    toDateService: "",
    invoiceType: "All",
    accountNo: "",
    scheme: "All",
    memberNo: "",
    showAllFilters: false
  });

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setFilters({
      ...filters,
      [name]: type === "checkbox" ? checked : value
    });
  };

  return (
    <Container fluid>
      <Card>
        <CardBody>

          <h5>View Invoices</h5>

          {/* Checkbox + Button in one row */}
          <Row className="align-items-center mb-3">
            <Col lg={6} className="d-flex align-items-center">
              <Input
                type="checkbox"
                name="showAllFilters"
                checked={filters.showAllFilters}
                onChange={handleChange}
                className="me-2"
              />
              <span>Show all filter options</span>
            </Col>
            <Col lg={6} className="d-flex justify-content-end">
              <Button color="success" style={{ height: "40px" }}>
                View today's invoices
              </Button>
            </Col>
          </Row>

          <Row>
            {/* Left Filters */}
            <Col lg={6}>
              <Label>
                Date of service from <span style={{ color: "red" }}>*</span>
              </Label>
              <Input
                type="date"
                name="fromDateService"
                value={filters.fromDateService}
                onChange={handleChange}
              />
              <Label className="mt-3">Invoice type</Label>
              <Input
                type="select"
                name="invoiceType"
                value={filters.invoiceType}
                onChange={handleChange}
              >
                <option>All</option>
                <option>Cash</option>
                <option>Credit</option>
              </Input>
              <Label className="mt-3">Account no.</Label>
              <Input
                type="text"
                name="accountNo"
                placeholder="Enter account no."
                value={filters.accountNo}
                onChange={handleChange}
              />
            </Col>

            {/* Middle Filters */}
            <Col lg={6}>
              <Label>
                Date of service to <span style={{ color: "red" }}>*</span>
              </Label>
              <Input
                type="date"
                name="toDateService"
                value={filters.toDateService}
                onChange={handleChange}
              />
              <Label className="mt-3">Scheme</Label>
              <Input
                type="select"
                name="scheme"
                value={filters.scheme}
                onChange={handleChange}
              >
                <option>All</option>
                <option>Scheme A</option>
                <option>Scheme B</option>
              </Input>
              <Label className="mt-3">Member no.</Label>
              <Input
                type="text"
                name="memberNo"
                placeholder="Enter member no."
                value={filters.memberNo}
                onChange={handleChange}
              />
            </Col>
          </Row>

          {/* Bottom Buttons */}
          <div className="d-flex justify-content-end mt-4">
            <Button color="secondary" className="me-2">
              Clear
            </Button>
            <Button color="warning">Search</Button>
          </div>
        </CardBody>
      </Card>
    </Container>
  );
};

export default ViewInvoice;
